module.exports = __webpack_public_path__ + "img/Signs2.398797ff.jpg";